import { ChangeDetectionStrategy, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { CpCompareMeasureCardComponent } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar-components/cp-compare-measure-card/cp-compare-measure-card.component';
import { CpCompareSidebarService, MeasureCard } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-cp-compare-measure-card-group',
  templateUrl: './cp-compare-measure-card-group.component.html',
  styleUrls: ['./cp-compare-measure-card-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareMeasureCardGroupComponent {

  @Input() measureCards: MeasureCard[];
  @Input() label: string;
  @Input() icon: string;

  @ContentChildren(CpCompareMeasureCardComponent) cards: QueryList<CpCompareMeasureCardComponent>;

  private selected$ = this.compareSidebarService.measureCards$.pipe(
    map(measureCards => this.cards.map(card => card.isSelected(measureCards))),
    map(selectedArr => selectedArr.some(Boolean)),
  );

  viewModel$ = combineLatest({
    selected: this.selected$,
  });

  constructor(
    private compareSidebarService: CpCompareSidebarService,
  ) {}

  async selectCards(selected: boolean) {
    if (selected) {
      this.measureCards.forEach(measureCard => {
        this.compareSidebarService.unSelectCard(measureCard);
      });
    }
    else {
      this.compareSidebarService.selectCards(this.measureCards);
    }
  }

}
